import { message } from 'antd';
import { Form } from '@ant-design/compatible';
import { filter, findIndex, includes, sortBy } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../../lib/router/withRouter';
import {
  MAXIMUM_NUMBER_OF_RECOMMEND_TAG_ITEM_COUNT,
  MINIMUM_NUMBER_OF_RECOMMEND_TAG_ITEM_COUNT,
} from '../../../constants/service/app/recommendTagConstants';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../../constants/service/common/utilConstants';
import { asyncSimpleModal } from '../../../lib/common';
import { recommendTagActions } from '../../../store/modules/recommend/tag';
import RecommendTagSaveWrap from '../../../views/recommend/tag/save/RecommendTagSaveWrap';

class RecommendTagSaveContainer extends Component {
  /**
   *  추천 태그 복사하기
   */
  onSubmit = () => {
    const { form, recommendTagSave, createRecommendTag } = this.props;
    const { recommendTagInfo, recommendTagItemList } = recommendTagSave;

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 150, offsetTop: 150 } }, async (err) => {
      if (err) return;

      /**
       *  추천 태그 아이템 최소 개수 체크
       */
      if (recommendTagItemList.selectedItemList.list.length < MINIMUM_NUMBER_OF_RECOMMEND_TAG_ITEM_COUNT) {
        message.error(`추천 태그 아이템은 최소 ${MINIMUM_NUMBER_OF_RECOMMEND_TAG_ITEM_COUNT}개이상입니다.`);
        return;
      }

      createRecommendTag({
        /**
         *  추천 태그 정보
         */
        recommendTagInfo: {
          /**
           *  추천 상품 후기 타입
           */
          type: recommendTagInfo.type,
          /**
           *  메모
           */
          memo: recommendTagInfo.memo,
        },
        /**
         *  추천 태그에 연결된 상품 후기 id 리스트
         */
        recommendTagItemIdList: recommendTagItemList.selectedItemList.idList,
      });
    });
  };

  /**
   *  추천 태그에 연결할 아이템 리스트 불러오기
   */
  getRecommendTagItemList = (option) => {
    const { getRecommendTagItemList, recommendTagSave } = this.props;
    const { recommendTagItemList } = recommendTagSave;
    const { filterOption, sortOption, pagination } = recommendTagItemList.itemList;

    getRecommendTagItemList({
      filterOption,
      sortOption,
      pagination,
      ...option,
    });
  };

  /**
   *  추천 태그에 연결할 아이템 선택하기
   */
  selectRecommendTagItemList = async (action, moveIdList) => {
    const { setData, recommendTagSave } = this.props;
    const { recommendTagItemList } = recommendTagSave;
    const { itemList, selectedItemList } = recommendTagItemList;

    /**
     *  업데이트 될 선택된 연결할 아이템 리스트
     */
    let updatedSelectRecommendTagItemList = [];

    /**
     *  연결할 아이템 아이템 추가
     */
    if (action === 'add') {
      let targetList = filter(itemList.list, (item) => includes(moveIdList, item.id));

      /**
       *  이전에 선택되어 있던 아이템 리스트와
       *  추가로 선택된 아이템을 합침
       */
      updatedSelectRecommendTagItemList = [...targetList, ...selectedItemList.list];

      /**
       *  추가하려고 하는 아이템 개수가 초과되었을 경우
       */
      if (updatedSelectRecommendTagItemList.length > MAXIMUM_NUMBER_OF_RECOMMEND_TAG_ITEM_COUNT) {
        await asyncSimpleModal({
          type: 'error',
          title: '아이템 개수 초과',
          message: `추천 태그 아이템 개수는 최대 ${MAXIMUM_NUMBER_OF_RECOMMEND_TAG_ITEM_COUNT} 입니다.`,
        });
        return;
      }
    } else if (action === 'remove') {
      /**
       *  연결할 아이템 아이템 해제
       */
      /**
       *  이전에 선택되어 있던 아이템 리스트에서
       *  해제한 아이템을 빼버림
       */
      updatedSelectRecommendTagItemList = filter(selectedItemList.list, (item) => !includes(moveIdList, item.id));
    }

    /**
     *  선택되어진 선택된 아이템은
     *  선택할 수 없도록 함
     */
    const updatedRecommendTagItemList = itemList.list.map((item) => ({
      ...item,
      uncheckable: includes(moveIdList, item.id) ? action === 'add' : item.uncheckable,
    }));
    setData({
      path: ['recommendTagSave', 'recommendTagItemList', 'itemList', 'list'],
      value: updatedRecommendTagItemList,
    });

    /**
     *  선택된 아이템 업데이트하기
     */
    setData({
      path: ['recommendTagSave', 'recommendTagItemList', 'selectedItemList'],
      value: {
        list: updatedSelectRecommendTagItemList,
        idList: updatedSelectRecommendTagItemList.map((item) => item.id),
      },
    });
  };

  /**
   *  추천 태그 리스트 아이템 순서 변경하기
   */
  onDragEndSelectRecommendStoreItemList = async (newList) => {
    const { setData, recommendTagSave } = this.props;
    const { recommendTagItemList } = recommendTagSave;
    const { selectedItemList } = recommendTagItemList;

    const updatedSelectRecommendTagItemList = sortBy(selectedItemList.list, (item) =>
      findIndex(newList, (_item) => _item.id === item.id),
    );

    await setData({
      path: ['recommendTagSave', 'recommendTagItemList', 'selectedItemList'],
      value: {
        list: updatedSelectRecommendTagItemList,
        idList: updatedSelectRecommendTagItemList.map((item) => item.id),
      },
    });
  };

  /**
   *  전체 태그 리스트 EXCEL 다운로드
   */
  getRecommendTagItemListExcelDownload = () => {
    const { getRecommendTagItemListExcelDownload, recommendTagSave, adminInfo } = this.props;
    const { recommendTagItemList } = recommendTagSave;
    const { filterOption, sortOption } = recommendTagItemList.itemList;

    getRecommendTagItemListExcelDownload({
      email: adminInfo.email,
      filterOption,
      sortOption,
    });
  };

  /**
   *  선택된 태그 리스트 EXCEL 다운로드
   */
  getSelectedRecommendTagItemListExcelDownload = () => {
    const { getSelectedRecommendTagItemListExcelDownload, recommendTagSave, adminInfo } = this.props;
    const { recommendTagItemList } = recommendTagSave;
    const { idList } = recommendTagItemList.selectedItemList;

    if (!idList.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getSelectedRecommendTagItemListExcelDownload({
      email: adminInfo.email,
      selectedRecommendTagItemIdList: idList,
    });
  };

  /**
   *  태그 리스트 EXCEL 업로드
   */
  setRecommendTagItemListExcelUpload = (file) => {
    const { setRecommendTagItemListExcelUpload } = this.props;

    setRecommendTagItemListExcelUpload({
      attachment: [file],
    });
  };

  render() {
    const { form, recommendTagSave, setData, typeDisabled } = this.props;

    return (
      <RecommendTagSaveWrap
        form={form}
        setData={setData}
        recommendTagSave={recommendTagSave}
        typeDisabled={typeDisabled}
        getRecommendTagItemList={this.getRecommendTagItemList}
        selectRecommendTagItemList={this.selectRecommendTagItemList}
        onSubmit={this.onSubmit}
        onDragEndSelectRecommendStoreItemList={this.onDragEndSelectRecommendStoreItemList}
        getRecommendTagItemListExcelDownload={this.getRecommendTagItemListExcelDownload}
        getSelectedRecommendTagItemListExcelDownload={this.getSelectedRecommendTagItemListExcelDownload}
        setRecommendTagItemListExcelUpload={this.setRecommendTagItemListExcelUpload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminInfo: state.app.adminInfo,
    recommendTagSave: state.recommendTag.recommendTagSave,
  };
};

const mapDispatchToProps = {
  setData: recommendTagActions.setData,
  getRecommendTagItemList: recommendTagActions.getRecommendTagItemList,
  createRecommendTag: recommendTagActions.createRecommendTag,
  getRecommendTagItemListExcelDownload: recommendTagActions.getRecommendTagItemListExcelDownload,
  getSelectedRecommendTagItemListExcelDownload: recommendTagActions.getSelectedRecommendTagItemListExcelDownload,
  setRecommendTagItemListExcelUpload: recommendTagActions.setRecommendTagItemListExcelUpload,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Form.create()(RecommendTagSaveContainer)));
